export default class HeaderBlock extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header');
    this.headerBg = document.querySelector('.header-bg');
    this.megamenuAll = this.querySelectorAll('.header__megamenu');
    this.headerBlock = document.querySelector('.header__block');
    this.menuItems = this.querySelectorAll('.header__menu-item:not(.has-submenu)');
    this.headerIcons = this.querySelectorAll('.header__icon');
    this.megamenuLinkItems = this.querySelectorAll('.header__submenu-item');
    this.megamenuBlockItems = this.querySelectorAll('.header__submenu-right__item');
    this.mobMenu = this.querySelector('.header__mob-menu');
    this.mobMenuOpenBtn = this.querySelector('.header__open-mob');
    this.mobMenuOpenSubmenu = this.querySelectorAll('.header__mob-menu__menu-item');
  }

  connectedCallback() {
    this.megamenuLinkItems.forEach(link => {
      link.addEventListener('mouseenter', () => this.activateMegamenuBlock(link));
    });

    this.megamenuAll.forEach(menu => {
      menu.addEventListener('mouseenter', () => this.activateMegamenu(menu));
    });

    this.menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => this.closeMegamenu());
    });

    this.headerIcons.forEach(item => {
      item.addEventListener('mouseenter', () => this.closeMegamenu());
    });

    if (this.mobMenuOpenBtn && this.mobMenu) {
      this.mobMenuOpenBtn.addEventListener('click', () => {
        this.headerBg.classList.toggle('m-show');
        this.mobMenuOpenBtn.classList.toggle('open');
        this.mobMenu.classList.toggle('open');
        this.headerBlock.classList.toggle('header__block-open');
        document.body.classList.toggle('overflow-hidden');

        if (this.classList.contains('has-filters')) {
          this.header.classList.toggle('m-index');
        }
      });
    }

    this.mobMenuOpenSubmenu.forEach(item => {
      item.addEventListener('click', (e) => {
        const parent = item.parentElement;
        if (parent) {
          parent.classList.toggle('m-open');
        }
      });
    });

    document.addEventListener('mousemove', (e) => {
      if (!this.header.contains(e.target)) {
        this.closeMegamenu();
      }
    });

    const updateScrollClass = () => {
      if (window.scrollY > 0) {
        this.classList.add('has-scroll');
        this.mobMenu.classList.add('has-scroll');
      } else {
        this.classList.remove('has-scroll');
        this.mobMenu.classList.remove('has-scroll');
      }
    };


    updateScrollClass();

    window.addEventListener('scroll', updateScrollClass);

    window.addEventListener('resize', () => {
      this.headerBg.classList.remove('m-show');
      this.mobMenuOpenBtn.classList.remove('open');
      this.mobMenu.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      this.header.classList.remove('m-index');
    });

    this.styleShopifyAccountAvatars();
    this.initFooterObserver();
  }

  initFooterObserver() {
    const footer = document.querySelector('.shopify-section-group-footer-group');
    if (!footer) return;

    const observer = new IntersectionObserver(([entry]) => {
      this.header.classList.toggle('header--hidden', entry.isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -350px 0px' });

    observer.observe(footer);
  }

  styleShopifyAccountAvatars() {
    const injectStyle = (el) => {
      if (!el.shadowRoot) return;
      const style = document.createElement('style');
      style.textContent = '.account-button__avatar { background-color: var(--color-primary) !important; }';
      el.shadowRoot.appendChild(style);
    };

    customElements.whenDefined('shopify-account').then(() => {
      this.querySelectorAll('shopify-account').forEach(el => {
        el.shadowRoot
          ? injectStyle(el)
          : new MutationObserver((_, obs) => { injectStyle(el); obs.disconnect(); })
              .observe(el, { childList: true, subtree: true });
      });
    });
  }

  activateMegamenuBlock(link) {
    this.megamenuLinkItems.forEach(item => item.classList.remove('active'));
    link.classList.add('active');

    const index = link.getAttribute('data-index');
    this.megamenuBlockItems.forEach(block => {
      block.classList.toggle('active', block.getAttribute('data-index') === index);
    });
  }

  activateMegamenu(menu) {
    this.megamenuAll.forEach(m => m.classList.remove('open'));
    menu.classList.add('open');
  }
  
  closeMegamenu() {
    this.megamenuAll.forEach(m => m.classList.remove('open'));
  }
}

customElements.define("header-block", HeaderBlock);
